module.exports = __webpack_public_path__ + "img/icon_clicks.598f214b.svg";